import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { css } from "styled-system/css";
import { useAuth } from "@/providers/AuthProvider";
import { fetchWithSessionSync } from "@/lib/fetch-with-session";
import { LoadingFrame } from "@/components/ui/loading-frame";

export function OdontogramByClient() {
  const { clientId } = useParams<{ clientId: string }>();
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!clientId) { navigate("/dashboard/odontogram", { replace: true }); return; }
    void (async () => {
      const r = await fetchWithSessionSync(
        `/api/dashboard/odontogram/by-client/${clientId}`,
        { credentials: "include" },
        refresh,
      );
      if (r.ok) {
        const data = (await r.json()) as {
          recordId: string | null;
          client: { clientId: string; firstName: string; lastName: string | null; email: string | null; phone: string | null } | null;
        };
        if (data.recordId) {
          navigate(`/dashboard/odontogram/${data.recordId}`, { replace: true });
        } else {
          // No record yet para este cliente — abrir la lista con el modal de "Nueva historia" prellenado
          navigate("/dashboard/odontogram", {
            replace: true,
            state: data.client
              ? {
                  openNewFor: {
                    clientId: data.client.clientId,
                    displayName: [data.client.firstName, data.client.lastName].filter(Boolean).join(" "),
                    email: data.client.email,
                    phone: data.client.phone,
                  },
                }
              : undefined,
          });
        }
      } else if (r.status === 403) {
        navigate("/dashboard/market", { replace: true });
      } else {
        navigate("/dashboard/odontogram", { replace: true });
      }
    })();
  }, [clientId, navigate, refresh]);

  return (
    <div className={css({ p: "8" })}>
      <LoadingFrame variant="light" minHeight={240} />
    </div>
  );
}
